/* eslint-disable no-unused-vars */
import * as React from 'react';
import { useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Button,ThemeProvider,createTheme } from "@mui/material";
import './style.css'; // Importez le fichier CSS
import anime from 'animejs';
import { cardData } from '../../Data/ArticleData';
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Footer from '../../Components/Footer';
import ScrollToTop from '../../Components/scrollup'
import HomeIcon from '@mui/icons-material/Home';
const categories = ['جميع الخدمات', 'مساج', 'حمام','تنظيف البشرة','بديكير','حلاقة'];
const customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,  
        sm: 600,
        md: 1080,  
        lg: 1280, 
      },
    },
    palette: {
      primary: {
        main: '#00897b',
        light: '#80cbc4',
        dark: '#00695c',
        contrastText: '#fff',
      },
    },
  });
export default function Blog() {
    useEffect(() => {
      anime({
        targets: ".iconContainer3",
        translateX: [400, 0],
        opacity: [0, 1],
        scale: [0, 1],
        delay: anime.stagger(200, { start: 300 }),
        easing: "easeInOutQuad",
      });
    }, []);
  
    useEffect(() => {
      const elements = document.querySelectorAll(".iconContainer3:not(.vide)");
      anime({
        targets: elements,
        translateX: [400, 0],
        opacity: [0, 1],
        scale: [0, 1],
        delay: anime.stagger(300, { start: 400 }),
        easing: "easeInOutQuad",
      });
    }, []);
  const [focusedCardIndex, setFocusedCardIndex] = React.useState(null);
  const [selectedCategory, setSelectedCategory] = React.useState('جميع الخدمات');

  const handleFocus = (index) => {
    setFocusedCardIndex(index);
  };

  const handleBlur = () => {
    setFocusedCardIndex(null);
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const filteredCardData = selectedCategory === 'جميع الخدمات'
    ? cardData
    : cardData.filter((card) => card.tag === selectedCategory);

  return (
        <ThemeProvider theme={customTheme}>
    <div className='blog'>
        <ScrollToTop/>
      <div className='blogHead'>
    
        <h1>
        الخدمات
        </h1>
        <div> <a href="/"><HomeIcon fontSize="small"/> <h5>الرئيسية</h5></a></div>
        </div>
        <div className='blogBody'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          width: '95%',
          justifyContent: 'space-between',
          alignItems: { xs: 'start', md: 'center' },
          gap: 4,
          overflow: 'auto',
          marginTop:'20px',
          marginLeft:{ xs: '0px', sm:'200px',md: '200px',lg:'200px'},
        }}
      >
        <Box className="chip-group">
          {categories.map((category) => (
          
            <Chip
              key={category}
              label={category}
              onClick={() => handleCategoryClick(category)}
              size="medium"
              className={`chip ${selectedCategory === category ? 'selected' : ''}`}
            />
        
          ))}
        </Box>
      </Box>
  <div className="presentation">
      <div className="present2">
      {filteredCardData.map((icon, index) => (
            <div key={index} className="iconContainer3">
              <div
                href={icon.name}
                target="_blank"
                rel="noreferrer"
                className="linkItems"
              >
                <img
                  src={require(`../../Images/programme/${icon.icon}.jpg`)}
                  alt={icon.name}
                  className="iconImg3"
                />
                <span>{icon.name}</span>
                <div>
                  <div className="price">
                    {icon.pricePromo ? (
                      <span
                        className="priceSpan"
                        style={{
                          textDecoration: "line-through",
                          color: "#151a5b",
                        }}
                      >
                        &nbsp;{icon.pricePromo} <span>ريال</span>
                      </span>
                    ) : (
                      <></>
                    )}
                    <span className="priceSpan">
                      {" "}
                      &nbsp;{icon.price} <span>ريال</span>{" "}
                    </span>
                  </div>
                  <a href={`/الخدمات/${icon.name}`}>
                    <Button
                      endIcon={<ArrowRightAltIcon />}
                      sx={{ marginTop: "20px" }}
                      variant="contained"
                      color="primary"
                      size="small"
                    >
                      أكثر تفاصيل
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          ))}
</div>
</div>
      </div>
      <Footer/>
    </div>
    </ThemeProvider>
  );
}
